<div ngFileDrop class="drag-n-drop-container" ngFileDrop
	[options]="options" (uploadOutput)="onUploadOutput($event)"
	[uploadInput]="uploadInput" [ngClass]="{ 'is-drop-over': dragOver }">
	<div *ngIf="showImportServiceModal.value && catalogData">
		<service-import-modal [catalogsDataString]="catalogData" [serviceId]="serviceId" (formSubmit)="startCopy($event)"></service-import-modal>
	</div>
		<label
		class="{{ !simpleButton ? 'upload-button file-input-wrapper btn btn-default form-control' : 'btn btn-outline-primary'}}">
		<input #fileInput type="file" class="hidden" ngFileSelect [options]="options"
		(uploadOutput)="onUploadOutput($event)"
		[uploadInput]="uploadInput" [ngClass]="{ 'is-drop-over': dragOver }">
		<i *ngIf='!hideIcon' class="fas fa-image mr-2"></i>
		<i *ngIf='isProcessing' class="fad fa-spinner-third fa-spin mr-2 mr-2"></i>
		<span *ngIf='!buttonLabel'>{{ 'Drop files to attach, or browse' | translate }}</span>
		<span *ngIf='buttonLabel'>{{ buttonLabel | translate }}</span>
	</label>
</div>
